export const reportViewList = [
    { id: 0, name: 'Summary' },
    { id: 1, name: 'Detailed' },
]

export const summaryColumn = [
    {
        id: 0, header: 'Serial Number', exportHead: 'Serial Number', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 40, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "50px" }, colSpan: 1
    },
    {
        id: 1, header: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentType', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 150, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "170px" }, colSpan: 1
    },
    {
        id: 3, header: 'Item Units', exportHead: 'Item Units', field: 'ItemUnits', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 4, header: 'Freight Charge', exportHead: 'Freight Chrg.', field: 'FreightCharge', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 110, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 5, header: 'KM Freight', exportHead: 'KM Freight', field: 'KMFreight', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 6, header: 'Booking Other Charge', exportHead: 'Booking Other Charge', field: 'BkgOthCharge', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 110, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 7, header: 'Delivery Cartage', exportHead: 'Del. Cart.', field: 'DelCart', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 8, header: 'Delivery Hamali', exportHead: 'Del. Ham.', field: 'DelHam', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 9, header: 'Extra Hameli', exportHead: 'Extra Hameli', field: 'ExtraHameli', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 110, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 10, header: 'Demurrage', exportHead: 'Demurrage', field: 'Demurrage', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 11, header: 'Delivery GST', exportHead: 'Del. GST', field: 'DelGST', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 12, header: 'Del.Discount (-)', exportHead: 'Del. Disc.(-)', field: 'DelDisc', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 13, header: 'Net Amount', exportHead: 'Net Amount', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "100px" }, colSpan: 1
    },
]

export const DetailedColumn = [
    {
        id: 0, header: 'S/N', exportHead: 'S/N', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 50, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "50px" }, colSpan: 1
    },
    {
        id: 1, header: 'LR No.\nMan. LR No.', exportHead: 'LR No.\nMan. LR No.', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 140, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "140px" }, colSpan: 1
    },
    {
        id: 2, header: 'Del. Date\nDel. Time', exportHead: 'Del. Date\nDel. Time', field: 'DelDate', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 110, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 3, header: 'Src. City\nSrc. Br.', exportHead: 'Src. City\nSrc. Br.', field: 'SrcCity', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "120px" }, colSpan: 1
    },
    {
        id: 4, header: 'Disp. By City\nDisp. By Br.', exportHead: 'Disp. By City\nDisp. By Br.', field: 'DispByCity', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "120px" }, colSpan: 1
    },
    {
        id: 5, header: 'Sndr. Name\nSndr. No.', exportHead: 'Sndr. Name\nSndr. No.', field: 'SndrName', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 6, header: 'Sndr. GSTIN\nSndr. eMail', exportHead: 'Sndr. GSTIN\nSndr. eMail', field: 'SndrGSTIN', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 7, header: 'Rcvr. Name\nRcvr. No.', exportHead: 'Rcvr. Name\nRcvr. No.', field: 'RcvrName', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 8, header: 'Rcvr. GSTIN\nRcvr. eMail', exportHead: 'Rcvr. GSTIN\nRcvr. eMail', field: 'RcvrGSTIN', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 9, header: 'Del. By\nItem', exportHead: 'Del. By\nItem', field: 'Item', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 10, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'ItemUnits', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 11, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'FrtChrg', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },

    {
        id: 12, header: 'KM Frt\nChrg.', exportHead: 'KM Frt\nChrg.', field: 'KMFrtChrg', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 13, header: 'Bkg. Oth\nChrg.', exportHead: 'Bkg. Oth\nChrg.', field: 'BkgOthChrg', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 14, header: 'Del.\nCart.', exportHead: 'Del.\nCart.', field: 'DelCart', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 15, header: 'Del.\nHam.', exportHead: 'Del.\nHam.', field: 'DelHam', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 16, header: 'Ext.\nHam.', exportHead: 'Ext.\nHam.', field: 'ExtHam', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 17, header: 'Dem.\nChrg.', exportHead: 'Dem.\nChrg.', field: 'DemChrg', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 18, header: 'Del.\nGST', exportHead: 'Del.\nGST', field: 'DelGST', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },

    {
        id: 19, header: 'Del.\nDisc.(-)', exportHead: 'Del.\nDisc.(-)', field: 'DelDisc', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 20, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmt', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
]
export const DetailedColumn1 = [
    {
        id: 0, header: 'S/N', exportHead: 'S/N', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 50, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "50px" }, colSpan: 1
    },
    {
        id: 1, header: 'LR No.\nMan. LR No.', exportHead: 'LR No.\nMan. LR No.', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 140, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "140px" }, colSpan: 1
    },
    {
        id: 21, header: 'Formatted LRNO', exportHead: 'Formatted LRNO', field: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 140, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "140px" }, colSpan: 1
    },
    {
        id: 2, header: 'Del. Date\nDel. Time', exportHead: 'Del. Date\nDel. Time', field: 'DelDate', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 110, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 3, header: 'Src. City\nSrc. Br.', exportHead: 'Src. City\nSrc. Br.', field: 'SrcCity', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "120px" }, colSpan: 1
    },
    {
        id: 4, header: 'Disp. By City\nDisp. By Br.', exportHead: 'Disp. By City\nDisp. By Br.', field: 'DispByCity', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "120px" }, colSpan: 1
    },
    {
        id: 5, header: 'Sndr. Name\nSndr. No.', exportHead: 'Sndr. Name\nSndr. No.', field: 'SndrName', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 6, header: 'Sndr. GSTIN\nSndr. eMail', exportHead: 'Sndr. GSTIN\nSndr. eMail', field: 'SndrGSTIN', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 7, header: 'Rcvr. Name\nRcvr. No.', exportHead: 'Rcvr. Name\nRcvr. No.', field: 'RcvrName', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 8, header: 'Rcvr. GSTIN\nRcvr. eMail', exportHead: 'Rcvr. GSTIN\nRcvr. eMail', field: 'RcvrGSTIN', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 9, header: 'Del. By\nItem', exportHead: 'Del. By\nItem', field: 'Item', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 10, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'ItemUnits', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 11, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'FrtChrg', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },

    {
        id: 12, header: 'KM Frt\nChrg.', exportHead: 'KM Frt\nChrg.', field: 'KMFrtChrg', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 13, header: 'Bkg. Oth\nChrg.', exportHead: 'Bkg. Oth\nChrg.', field: 'BkgOthChrg', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 14, header: 'Del.\nCart.', exportHead: 'Del.\nCart.', field: 'DelCart', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 15, header: 'Del.\nHam.', exportHead: 'Del.\nHam.', field: 'DelHam', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 16, header: 'Ext.\nHam.', exportHead: 'Ext.\nHam.', field: 'ExtHam', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 17, header: 'Dem.\nChrg.', exportHead: 'Dem.\nChrg.', field: 'DemChrg', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 18, header: 'Del.\nGST', exportHead: 'Del.\nGST', field: 'DelGST', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },

    {
        id: 19, header: 'Del.\nDisc.(-)', exportHead: 'Del.\nDisc.(-)', field: 'DelDisc', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 20, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmt', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
]
export const DetailedRemoveGSTColumn = [
    {
        id: 0, header: 'S/N', exportHead: 'S/N', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 50, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "50px" }, colSpan: 1
    },
    {
        id: 1, header: 'LR No.\nMan. LR No.', exportHead: 'LR No.\nMan. LR No.', field: 'LRNO', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 140, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "140px" }, colSpan: 1
    },
    {
        id: 21, header: 'Formatted LRNO', exportHead: 'Formatted LRNO', field: 'FormattedLRNO', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 140, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "140px" }, colSpan: 1
    },
    {
        id: 2, header: 'Del. Date\nDel. Time', exportHead: 'Del. Date\nDel. Time', field: 'DelDate', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 110, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 3, header: 'Src. City\nSrc. Br.', exportHead: 'Src. City\nSrc. Br.', field: 'SrcCity', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "120px" }, colSpan: 1
    },
    {
        id: 4, header: 'Disp. By City\nDisp. By Br.', exportHead: 'Disp. By City\nDisp. By Br.', field: 'DispByCity', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "120px" }, colSpan: 1
    },
    {
        id: 5, header: 'Sndr. Name\nSndr. No.', exportHead: 'Sndr. Name\nSndr. No.', field: 'SndrName', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 6, header: 'Sndr. eMail', exportHead: 'Sndr. eMail', field: 'SndrGSTIN', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 7, header: 'Rcvr. Name\nRcvr. No.', exportHead: 'Rcvr. Name\nRcvr. No.', field: 'RcvrName', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 8, header: 'Rcvr. eMail', exportHead: 'Rcvr. eMail', field: 'RcvrGSTIN', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 9, header: 'Del. By\nItem', exportHead: 'Del. By\nItem', field: 'Item', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { textAlign: 'left', minWidth: "100px" }, colSpan: 1
    },
    {
        id: 10, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'ItemUnits', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 11, header: 'Frt.\nChrg.', exportHead: 'Frt.\nChrg.', field: 'FrtChrg', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },

    {
        id: 12, header: 'KM Frt\nChrg.', exportHead: 'KM Frt\nChrg.', field: 'KMFrtChrg', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 13, header: 'Bkg. Oth\nChrg.', exportHead: 'Bkg. Oth\nChrg.', field: 'BkgOthChrg', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 14, header: 'Del.\nCart.', exportHead: 'Del.\nCart.', field: 'DelCart', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 15, header: 'Del.\nHam.', exportHead: 'Del.\nHam.', field: 'DelHam', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 16, header: 'Ext.\nHam.', exportHead: 'Ext.\nHam.', field: 'ExtHam', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 17, header: 'Dem.\nChrg.', exportHead: 'Dem.\nChrg.', field: 'DemChrg', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    // {
    //     id: 18, header: 'Del.\nGST', exportHead: 'Del.\nGST', field: 'DelGST', isSelected: true, isDefault: false, isMandatory: false,
    //     pdfColSx: {
    //         halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    //     },
    //     xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    // },

    {
        id: 18, header: 'Del.\nDisc.(-)', exportHead: 'Del.\nDisc.(-)', field: 'DelDisc', isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
    {
        id: 19, header: 'Net\nAmt.', exportHead: 'Net\nAmt.', field: 'NetAmt', isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
        },
        xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { textAlign: 'right', minWidth: "90px" }, colSpan: 1
    },
]
export const detailedExcelColumn = [
    { header: 'Serial number', field: 'srNo' },
    { header: 'LR number', field: 'LRNO' },
    { header: 'Manual LR number', field: 'LRNO' },
    { header: 'Formatted LR number', field: 'FormattedLRNO' },
    { header: 'Delivery Date', field: 'DelDate' },
    { header: 'Delivery Time', field: 'DelDate' },
    { header: 'Source City', field: 'SrcCity' },
    { header: 'Source Branch', field: 'SrcCity' },
    { header: 'Dispatch By City', field: 'DispByCity' },
    { header: 'Dispatch By Branch', field: 'DispByCity' },
    { header: 'Sender Name', field: 'SndrName' },
    { header: 'Sender number', field: 'SndrName' },
    { header: 'Sender GSTIN', field: 'SndrGSTIN' },
    { header: 'Sender eMail', field: 'SndrGSTIN' },
    { header: 'Receiver Name', field: 'RcvrName' },
    { header: 'Receiver number', field: 'RcvrName' },
    { header: 'Receiver GSTIN', field: 'RcvrGSTIN' },
    { header: 'Receiver eMail', field: 'RcvrGSTIN' },
    { header: 'Delivery By', field: 'Item' },
    { header: 'Item', field: 'Item' },
    { header: 'Item Units', field: 'ItemUnits' },
    { header: 'Freight Charge', field: 'FrtChrg' },
    { header: 'KM Freight Charge', field: 'KMFrtChrg' },
    { header: 'Booking Other Charge', field: 'BkgOthChrg' },
    { header: 'Delivery Cartage', field: 'DelCart' },
    { header: 'Delivery Hamali', field: 'DelHam' },
    { header: 'Extra Hamali', field: 'ExtHam' },
    { header: 'Demurrage Charge', field: 'DemChrg' },
    { header: 'Delivery GST', field: 'DelGST' },
    { header: 'Delivery Discription', field: 'DelDisc' },
    { header: 'Net Amount', field: 'NetAmt' },
]
export const detailedExcelRemoveGSTColumn = [
    { header: 'Serial number', field: 'srNo' },
    { header: 'LR number', field: 'LRNO' },
    { header: 'Manual LR number', field: 'LRNO' },
    { header: 'Formatted LR number', field: 'FormattedLRNO' },
    { header: 'Delivery Date', field: 'DelDate' },
    { header: 'Delivery Time', field: 'DelDate' },
    { header: 'Source City', field: 'SrcCity' },
    { header: 'Source Branch', field: 'SrcCity' },
    { header: 'Dispatch By City', field: 'DispByCity' },
    { header: 'Dispatch By Branch', field: 'DispByCity' },
    { header: 'Sender Name', field: 'SndrName' },
    { header: 'Sender number', field: 'SndrName' },
    { header: 'Sender GSTIN', field: 'SndrGSTIN' },
    { header: 'Sender eMail', field: 'SndrGSTIN' },
    { header: 'Receiver Name', field: 'RcvrName' },
    { header: 'Receiver number', field: 'RcvrName' },
    { header: 'Receiver eMail', field: 'RcvrGSTIN' },
    { header: 'Delivery By', field: 'Item' },
    { header: 'Item', field: 'Item' },
    { header: 'Item Units', field: 'ItemUnits' },
    { header: 'Freight Charge', field: 'FrtChrg' },
    { header: 'KM Freight Charge', field: 'KMFrtChrg' },
    { header: 'Booking Other Charge', field: 'BkgOthChrg' },
    { header: 'Delivery Cartage', field: 'DelCart' },
    { header: 'Delivery Hamali', field: 'DelHam' },
    { header: 'Extra Hamali', field: 'ExtHam' },
    { header: 'Demurrage Charge', field: 'DemChrg' },
    { header: 'Delivery Discription', field: 'DelDisc' },
    { header: 'Net Amount', field: 'NetAmt' },
]

export const frenchDeliveryUpdatedColumn = (allowFormatLR, loginCountryId) => {
    const lrCols = [];
    if (allowFormatLR === 3) {
        lrCols.push({
            id: 1,
            header: "LR No.\nMan. LR No.",
            exportHead: "LR Number\nManual LR Number",
            field: "LRNO^^ManualLRNo",
            isSelected: true, isDefault: true, isMandatory: true,
            xlCol: { dataType: "string", dataFormatter: null },
            pdfColSx: { halign: "left", textColor: [0, 0, 0], fontSize: 16, minCellWidth: 120, cellPadding: 6, font: "Roboto", valign: "top", minCellHeight: 36 },
            headerSx: { textAlign: "left" },
            width:'120px',
        });
        lrCols.push({
            id: 2,
            header: "Formatted LR No",
            exportHead: "Formatted LR Number",
            field: "FormattedLRNO",
            isSelected: true, isDefault: true, isMandatory: false,
            xlCol: { dataType: "string", dataFormatter: null },
            pdfColSx: { halign: "left", textColor: [0, 0, 0], fontSize: 16, minCellWidth: 90, cellPadding: 6, font: "Roboto", valign: "top", minCellHeight: 36 },
            headerSx: { textAlign: "left" },
            width:'90px',
        });
    }
    else if (allowFormatLR === 2) {
        lrCols.push({
            id: 1,
            header: "LR No.",
            exportHead: "LR Number",
            field: "LRNO",
            isSelected: true, isDefault: true, isMandatory: true,
            xlCol: { dataType: "string", dataFormatter: null },
            pdfColSx: { halign: "left", textColor: [0, 0, 0], minCellWidth: 80, cellPadding: 6, font: "Roboto" },
            headerSx: { textAlign: "left" },
            width:'120px',
        });
        lrCols.push({
            id: 2,
            header: "Formatted LR No",
            exportHead: "Formatted LR Number",
            field: "FormattedLRNO",
            isSelected: true, isDefault: true, isMandatory: false,
            xlCol: { dataType: "string", dataFormatter: null },
            pdfColSx: { halign: "left", textColor: [0, 0, 0], minCellWidth: 90, cellPadding: 6, font: "Roboto" },
            headerSx: { textAlign: "left" },
            width:'120px',
        });
    }
    else {
        lrCols.push({
            id: 1,
            header: "LR No.\nMan. LR No.",
            exportHead: "LR Number\nManual LR Number",
            field: "LRNO^^ManualLRNo",
            isSelected: true, isDefault: true, isMandatory: true,
            xlCol: { dataType: "string", dataFormatter: null },
            pdfColSx: { halign: "left", textColor: [0, 0, 0], minCellWidth: 120, cellPadding: 6, font: "Roboto" },
            headerSx: { textAlign: "left" },
            width:'120px',
        });
    }
    return [
        {
            id: 0, header: 'S/N', exportHead: 'Serial Number', field: 'srNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
            pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 31, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'right' },
            width:'120px',
        },
        ...lrCols,
        {
            id: 2, header: 'Del. Date\nDel. Time', exportHead: 'Delivery Date\nDelivery Time', field: 'DelDate', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
            pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 81, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'left' },
            width:'120px',
        },
        {
            id: 3, header: 'Src. City\nSrc. Br.', exportHead: 'Source City\nSource Branch', field: 'SourceCity^^SourceBranch', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
            pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'left' }
,
width:'120px',        },
        {
            id: 4, header: 'Disp. By City\nDisp. By Br.', exportHead: 'Dispatch By City\nDispatch By Branch', field: 'DispatchedByCity^^DispatchedByBranch', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
            pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 81, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'left' }
,
width:'120px',        },
        {
            id: 5, header: 'Sndr. Name\nSndr. Cont.', exportHead: 'Sender Name\nSender Contact', field: 'Sender^^SenderMobileNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
            pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 81, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'left' }
,
width:'120px',        },
        {
            id: 6, header: loginCountryId === 2 ? 'Sndr. eMail' : 'Sndr. GSTIN\nSndr. eMail', exportHead: loginCountryId === 2 ? 'Sender EMail' : 'Sender GSTIN\nSender EMail', field: loginCountryId === 2 ? 'SenderEmailID' : 'SenderGSTN^^SenderEmailID', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
            pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'left' }
,
width:'120px',        },
        {
            id: 7, header: 'Rcvr. Name\nRcvr. No.', exportHead: 'Receiver Name\nReceiver Number', field: 'RecName^^RecMobileNo', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
            pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 80, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'left' }
,
width:'120px',        },
        {
            id: 8, header: loginCountryId === 2 ? 'Rcvr. eMail' : 'Rcvr. GSTIN \nRcvr. eMail', exportHead: loginCountryId === 2 ? 'Receiver EMail' : 'Receiver GSTIN \nReceiver EMail', field: loginCountryId === 2 ? 'RecEmailID' : 'RecGSTN^^RecEmailID', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'string', dataFormatter: null },
            pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 81, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'left' }
,
width:'120px',        },
        {
            id: 9, header: 'Del. By\nItem', exportHead: 'Delivery By\nItem', field: 'DeliveredBy^^ItemDetails', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'string', dataFormatter: null },
            pdfColSx: { halign: 'left', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 64, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'left' }
,
width:'120px',        },
        {
            id: 10, header: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Items', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
            pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 70, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'right' },
            width:'120px',
        },
        {
            id: 11, header: 'Frt.\nChrg.', exportHead: 'Freight\nCharge', field: 'Freight', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
            pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 70, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'right' },
            width:'120px',
        },
        {
            id: 12, header: 'KM\nFrt.', exportHead: 'Kilometre\nFreight', field: 'KMSFreight', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
            pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 70, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'right' },
            width:'120px',
        },
        {
            id: 13, header: 'Bkg.\nOth', exportHead: 'Booking\nOther', field: 'BkgOtherCharges', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
            pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 70, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'right' },
            width:'120px',
        },
        {
            id: 14, header: 'Del.\nCart.', exportHead: 'Delivery\nCartage', field: 'DeliveryCartage', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
            pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 70, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'right' },
            width:'120px',
        },
        {
            id: 15, header: 'Del.\nHam.', exportHead: 'Delivery\nHamali', field: 'DeliveryHamali', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
            pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 70, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'right' },
            width:'120px',
        },
        {
            id: 16, header: 'Ext.\nHam.', exportHead: 'Extra\nHamali', field: 'ExtraHamali', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
            pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 70, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'right' },
            width:'120px',
        },
        {
            id: 17, header: 'Dem.\nChrg.', exportHead: 'Demurrage\nCharge', field: 'DemurrageChg', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
            pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 70, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'right' },
            width:'120px',
        },
        loginCountryId === 2 && {
            id: 18, header: 'Del.\nGST', exportHead: 'Delivery\nGST', field: 'DeliveryGST', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
            pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 70, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'right' },
            width:'120px',
        },
        {
            id: 19, header: 'Del.\nDisc.', exportHead: 'Delivery\nDiscount', field: 'DeliveryDiscount', isSelected: true, isDefault: false, isMandatory: false, xlCol: { dataType: 'number', dataFormatter: null },
            pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 70, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'right' },
            width:'120px',
        },
        {
            id: 20, header: 'Net\nAmt.', exportHead: 'Net\nAmount', field: 'NetAmount', isSelected: true, isDefault: true, isMandatory: true, xlCol: { dataType: 'number', dataFormatter: null },
            pdfColSx: { halign: 'right', textColor: [0, 0, 0], fontSize: 16, minCellWidth: 70, cellPadding: 6, font: 'Roboto', fontStyle: "normal", valign: 'top', minCellHeight: 36, },
            headerSx: { textAlign: 'right' },
            width:'120px',
        },
    ].filter(Boolean)
}

export const filterHeader = [
    { header: 'Franchise Company', field: "FranchiseCompany" },
    { header: 'Franchisee Del. City', field: "FranchiseeDelCity" },
    { header: 'Franchisee Del. Branch', field: "FranchiseeDelBranch" },
    { header: 'Own Booking City', field: "OwnBookingCity" },
]
export const filterHeader1 = [
    { header: 'Own Booking Branch', field: "OwnBookingBranch", xlCol: { dataType: 'string' } },
    { header: 'Own Booking Branch User', field: "OwnBookingBranchUser", xlCol: { dataType: 'string' } },
    { header: 'Payment Type', field: "PaymentType", xlCol: { dataType: 'string' } },
    { header: 'Payment Mode', field: "PaymentMode", xlCol: { dataType: 'string' } },
    { header: 'Report View', field: "ReportView", xlCol: { dataType: 'string' } },
]